import { getGlobalEventsLogs } from '@cian/events-log';

import { NonEmptyArray } from 'shared/common/packages/JsonQuery';

import { normalizeRegionId } from '../region';

export function produceGeoChangeEvent(regionIds: NonEmptyArray<number>): void {
  const regionId = normalizeRegionId(regionIds);

  const globalLog = getGlobalEventsLogs();

  globalLog.produce('geo', {
    type: 'updateRegion',
    value: { regionId },
  });
}
